<template>
  <div id="worktimereport" class="report">
    <v-row>
      <v-col class="document-title">
        <h1 v-if="params.user && params.user.id">Delovni čas prodajalca</h1>
        <h1 v-else>Delovni čas prodajalcev</h1>
      </v-col>
    </v-row>
    <ReportPrintAllHeader :params="params" />

    <!-- <v-row class="table-header">
      <v-col>
        Datum prijave
      </v-col>
      <v-col>
        Uporabnik
      </v-col>
      <v-col>
        Čas prijave
      </v-col>
      <v-col>
        Blagajna prijave
      </v-col>
      <v-col>
        Datum odjave
      </v-col>
      <v-col>
        Čas odjave
      </v-col>
      <v-col>
        Blagajna odjave
      </v-col>
      <v-col>
        Stanje ob prijavi
      </v-col>
      <v-col>
        Stanje ob odjavi
      </v-col>
      <v-col>
        Razlika
      </v-col>
      <v-col>
        Promet gotovina
      </v-col>
      <v-col>
        Promet kartica
      </v-col>
      <v-col>
        Vrednost preklicanih miz
      </v-col>
      <v-col>
        Opravljenih ur
      </v-col>
    </v-row>

    <div v-for="(date, index) in data" :key="index">
        <MyWorktimeRow
          v-for="(dayData, index) in date"
          :key="index"
          :dayData="dayData"
          @refresh="refre"
          @emitForm="setCurrentForm"
        />
    </div> -->
    <h2>Prikaz prijav in odjav v izbranem obdobju</h2>
    <v-simple-table
        fixed-header
        id="workTimeDataTable"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Datum prijave
              </th>
              <th class="text-left">
                Uporabnik
              </th>
              <th class="text-left">
                Čas prijave
              </th>
              <th class="text-left">
                Datum odjave
              </th>
              <th class="text-left">
                Čas odjave
              </th>
              <th class="text-left">
                Stanje ob prijavi
              </th>
              <th class="text-left">
                Stanje ob odjavi
              </th>
              <th class="text-left">
                Razlika
              </th>
              <th class="text-left">
                Opravljenih ur
              </th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <template v-for="(dayDate) in data">
              <!-- <tr :key="index"><td></td></tr> -->
              <MyWorktimeRow
                v-for="(dayData, index) in dayDate"
                :plain="true"
                :key="index"
                :dayData="dayData"
                @refresh="refre"
                @emitForm="setCurrentForm"
              />
            </template>
          </tbody>
        </template>
      </v-simple-table>

    <h2 style="page-break-before: always;">Podatki uporabnikov v izbranem obdobju</h2>
    <!-- {{ reportDataSummary }} -->
    <v-row>
      <v-simple-table
        id="tableTwo"
        fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr style="border-bottom:1px solid #000;">
                <th class="text-left">
                  Uporabnik
                </th>
                <!-- th class="text-left">
                  Promet gotovina
                </th>
                <th class="text-left">
                  Promet kartica
                </th>
                <th class="text-left">
                  Promet skupaj
                </th> -->
                <th class="text-center">
                  Opravljenih ur
                </th>
              </tr>
            </thead>
            <tbody v-if="!loading">
              <MyWorktimeSummaryRow
                  v-for="(userReport, index) in reportDataSummary"
                  ref="myworktimesummary"
                  :plain="true"
                  :key="`${index}ta`"
                  :userReport="userReport"
                />
            </tbody>
          </template>
      </v-simple-table>
    </v-row>
  </div>
</template>

<script>
import ReportPrintAllHeader from './ReportPrintAllHeader'
import MyWorktimeRow from './MyWorktimeRow'
import MyWorktimeSummaryRow from '@/components/MyWorktimeSummaryRow'

export default {
  components: {
    ReportPrintAllHeader,
    MyWorktimeSummaryRow,
    MyWorktimeRow,
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    reportDataSummary: {
      required: true,
      type: Array
    },
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    total () {
      return this.data.reduce((total, item) => total + item.total, 0)
    }
  },
  created() {
    if (!this.params.startTime) {
      this.params.startTime = '00:00'
    }
  },
  mounted() {
    this.$refs.setCurrentRowData.setCurrentRowData()
    if (!this.params.startTime) {
      this.params.startTime = '00:00'
    }
  }
}
</script>

<style scoped lang="scss">
  .theme--light.v-application {
    background-color: white;
  }
</style>

<style lang="scss" scoped>
html, body {
  font-size: 21px;
}
.report {
  padding: 30px 20px;
}
.document-title {
  margin-bottom: 30px;
  text-align: center;
}
.table-title {
  background-color: #eaeaea;
  font-weight: bold;
}
.table-header,
.table-footer {
  border: 1px solid black;
  background-color: #e5e5e5;
  font-weight: bold;
  font-size: 21px;
}
.devider {
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-top: 1px solid black;
}
.row.condenced {
  .col {
    padding: 5px;
  }
}

head > tr > * {
  border-bottom: 1px solid #000 !important;
}
td:empty::after {
  content: "\00a0";
}

#worktimereport {
  background-color: red;
}

@page {
  size: landscape;
}
</style>
